/* @flow */

import SortAction from "./SortAction";
import ObjectDetailDrill from "./ObjectDetailDrill";
import QuickFilterDrill from "./QuickFilterDrill";
import UnderlyingRecordsDrill from "./UnderlyingRecordsDrill";
import AutomaticDashboardDrill from "./AutomaticDashboardDrill";
import ZoomDrill from "./ZoomDrill";

export const DEFAULT_DRILLS = [
  ZoomDrill,
  SortAction,
  ObjectDetailDrill,
  QuickFilterDrill,
  UnderlyingRecordsDrill,
  AutomaticDashboardDrill,
];



// WEBPACK FOOTER //
// ./qb/components/drill/index.js